export const formatXml = (xml: string): string => {
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(xml, "application/xml")

    if (doc.querySelector("parsererror")) {
      return xml
    }

    const serializer = new XMLSerializer()
    const rawXml = serializer.serializeToString(doc)

    let formatted = ""
    let indent = 0
    const parts = rawXml.replace(/>\s*</g, "><").split(/(<[^>]+>)/g)
    let inSimpleElement = false

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      if (!part.trim()) continue

      const isClosingTag = part.startsWith("</")
      const isSelfClosing = part.endsWith("/>")
      const isProcessingInstruction = part.startsWith("<?")
      const isOpeningTag = part.startsWith("<") && !isClosingTag && !isSelfClosing && !isProcessingInstruction
      const isTextContent = !part.startsWith("<")

      if (isClosingTag) {
        if (inSimpleElement) {
          formatted += part + "\n"
          inSimpleElement = false
        } else {
          indent = Math.max(0, indent - 1)
          formatted += "  ".repeat(indent) + part + "\n"
        }
      } else if (isProcessingInstruction || isSelfClosing) {
        formatted += "  ".repeat(indent) + part + "\n"
      } else if (isOpeningTag) {
        const nextPart = parts[i + 1]
        const afterNext = parts[i + 2]
        const tagName = part.slice(1, part.indexOf(" ") > 0 ? part.indexOf(" ") : part.indexOf(">"))
        const isSimpleElement = nextPart && !nextPart.startsWith("<") && afterNext === `</${tagName}>`

        if (isSimpleElement) {
          formatted += "  ".repeat(indent) + part
          inSimpleElement = true
        } else {
          formatted += "  ".repeat(indent) + part + "\n"
          indent++
        }
      } else if (isTextContent) {
        formatted += part
      }
    }

    return formatted.trim()
  } catch {
    return xml
  }
}
